<script setup lang="ts">
import RepairSection from '@/components/rc/miner-repairs/repairs-sidebar/RepairSection.vue'
import RepairImagesSubsection from '@/components/rc/miner-repairs/repairs-sidebar/part-sidebar-sections/repair-details-subsections/RepairImagesSubsection.vue'
import RepairItemsSubsection from '@/components/rc/miner-repairs/repairs-sidebar/part-sidebar-sections/repair-details-subsections/RepairItemsSubsection.vue'
import ReplacePartSubsection from '@/components/rc/miner-repairs/repairs-sidebar/part-sidebar-sections/repair-details-subsections/ReplacePartSubsection.vue'
import UsedComponentsSubsection from '@/components/rc/miner-repairs/repairs-sidebar/part-sidebar-sections/repair-details-subsections/UsedComponentsSubsection.vue'

import { useRepairsContext } from '@/composables/rc/drawer-context'
import { usePartDetails } from '@/composables/rc/part-details'
import { computed } from 'vue'
import PartNotesSubsection from './repair-details-subsections/PartNotesSubsection.vue'

defineProps<{ failureId: number }>()

// Context - BE
const { minerId, selectedPart } = useRepairsContext()
const { hasRepairItems, hasReplacedComponents, hasRepairPictures, hasRepairNotes, isHb } = usePartDetails(
  minerId,
  selectedPart
)

const isSectionChecked = computed(
  () => hasRepairItems.value || hasReplacedComponents.value || hasRepairPictures.value || hasRepairNotes.value
)
</script>

<template>
  <RepairSection title="Repair Details" :step="2" :active="isSectionChecked">
    <RepairItemsSubsection :failure-id="failureId" />
    <UsedComponentsSubsection v-if="isHb" />
    <ReplacePartSubsection />
    <RepairImagesSubsection />
    <PartNotesSubsection />
  </RepairSection>
</template>
